import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const DECIMAL_CHARS_PATTERN = /^-?[\d,.]+$/;
const US_GROUPED_INTEGER_PATTERN = /^\d{1,3}(,\d{3})*$/;

export function customFieldDecimal(
  formatStr: string,
  message = 'Invalid amount',
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined) {
      return null;
    }

    const value = String(control.value).trim();
    if (!value) {
      return null;
    }

    if (!DECIMAL_CHARS_PATTERN.test(value)) {
      return { decimal: message };
    }

    const dotCount = (value.match(/\./g) ?? []).length;
    if (dotCount > 1) {
      return { decimal: message };
    }

    const [integerPart, fractionPart] = value.split('.');
    const signedInteger = integerPart ?? '';
    const digitsOnlyInteger = signedInteger.replace(/,/g, '');

    if (!/^-?\d+$/.test(digitsOnlyInteger)) {
      return { decimal: message };
    }

    if (signedInteger.includes(',')) {
      const unsignedInteger = signedInteger.startsWith('-')
        ? signedInteger.slice(1)
        : signedInteger;

      if (!US_GROUPED_INTEGER_PATTERN.test(unsignedInteger)) {
        return { decimal: message };
      }
    }

    if (fractionPart !== undefined) {
      if (!formatAllowsDecimal(formatStr)) {
        return { decimal: message };
      }

      if (fractionPart && !/^\d+$/.test(fractionPart)) {
        return { decimal: message };
      }

      const maxFractionDigits = getMaxFractionDigits(formatStr);
      if (maxFractionDigits > 0 && fractionPart.length > maxFractionDigits) {
        return { decimal: message };
      }
    }

    return null;
  };
}

function formatAllowsDecimal(formatStr: string): boolean {
  if (!formatStr?.trim()) {
    return true;
  }
  return formatStr.includes('.');
}

function getMaxFractionDigits(formatStr: string): number {
  const match = formatStr?.match(/\.([0#]+)/);
  return match ? match[1].length : 0;
}
